export const archiveReasons = [
  "Churned",
  "Test Customer / Account",
  "Trial Period",
  "Duplicated Account",
  "Never Onboarded",
  "Paused Account",
  "No reason provided",
];
